import React from 'react';
import { useNavigate } from 'react-router-dom';
import { truncateText, formatRelativeTime, formatAgeRange } from '../utils/formatters';
import { getAgeGroupSettings } from '../utils/age-groups';
import './StoryCard.css';

const StoryCard = ({ story, onDelete }) => {
  const navigate = useNavigate();
  
  if (!story || !story.id) {
    return null;
  }
  
  // Get first scene image for card thumbnail
  const thumbnailImage = story.scenes && story.scenes[0] && story.scenes[0].imageUrl 
    ? story.scenes[0].imageUrl 
    : 'https://images.unsplash.com/photo-1518020382113-a7e8fc38eac9?q=80&w=1000&auto=format&fit=crop';
  
  // Get text preview from first scene
  const previewText = story.scenes && story.scenes[0] 
    ? truncateText(story.scenes[0].text, 120) 
    : 'No preview available';
  
  // Format the age range
  const ageGroup = story.ageGroup ? getAgeGroupSettings(story.ageGroup) : null;
  const ageRangeDisplay = ageGroup ? formatAgeRange(ageGroup.ageRange) : '';
  
  // Handle click to view story
  const handleViewStory = (e) => {
    e.stopPropagation();
    navigate(`/story/${story.id}`);
  };
  
  // Handle click to delete story
  const handleDeleteStory = (e) => {
    e.stopPropagation();
    // Confirm before deleting
    if (window.confirm('Are you sure you want to delete this story?')) {
      if (onDelete) onDelete(story.id);
    }
  };
  
  return (
    <div className="story-card" onClick={handleViewStory}>
      <div className="story-card-image" style={{ backgroundImage: `url(${thumbnailImage})` }}>
        {ageGroup && (
          <span className="story-card-age-tag">Ages {ageRangeDisplay}</span>
        )}
      </div>
      
      <div className="story-card-content">
        <h3 className="story-card-title">{story.title}</h3>
        
        <p className="story-card-preview">{previewText}</p>
        
        <div className="story-card-meta">
          {story.createdAt && (
            <span className="story-card-time">{formatRelativeTime(story.createdAt)}</span>
          )}
        </div>
        
        <div className="story-card-actions">
          <button 
            className="pill-button primary-sm" 
            onClick={handleViewStory}
            aria-label="Read story"
          >
            Read Story
          </button>
          
          <button 
            className="pill-button delete-sm" 
            onClick={handleDeleteStory}
            aria-label="Delete story"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default StoryCard;
